
export default function ListeningState({ muted }) {
  return (
    <div className="ai-state-container">\
          <div className="ai-circle-background">
      </div>
      {/* Ripple effect for better visual feedback */}
      <div className="ai-ripple-container">
        <div className="ai-ripple ai-ripple-1"></div>
        <div className="ai-ripple ai-ripple-2"></div>
        <div className="ai-ripple ai-ripple-3"></div>
      </div>
    </div>
  );
}
